import useGetQuery from '_api/queries/useGetQuery';
import { ConstantsNameDescriptions, SpecializationName } from '_api/types';

export const GET_THERAPIST_SPECIALIZATION = 'get-therapist-specialization';

export const useGetTherapistSpecializations = () =>
  useGetQuery<ConstantsNameDescriptions<SpecializationName>[]>(
    () => `/constant/therapist-specializations`,
    {},
    [GET_THERAPIST_SPECIALIZATION],
    {
      refetchOnWindowFocus: false,
    },
  );
